<template>
  <div class="page-error">
    <img class="e-img" :src="require('@/assets/images/error.png')" alt="">
    <div class="tishi">抱歉！您访问的页面暂无内容</div>
    <router-link to="/" class="go-index"><i class="el-icon-back"></i> 返回首页</router-link>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  components: {

  },
  data () {
    return {

    }
  }
}
</script>

<style scoped lang="less">
.page-error{
  padding-bottom: 10vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  .e-img{
    max-width: 100%
  }
  .tishi{
    color: #666;
    font-size: 14px;
  }
  .go-index{
    margin-top: 5px;
    color: #409eff;
    font-size: 14px;
  }
}
</style>
